<template>
  <!-- 行样式配置 -->
  <div>
    <ku-drawer :title="$t('行样式')" :visible.sync="drawerVisible" size="676px" :loading="loading" @confirm="rowStyleSetSubmit" @closed="$emit('closeRowStyle')">
      <div slot="title">
        <div class="drawer-title-text">
          <span>{{ $t('行样式') }}</span>
          （{{ $t('长按拖动可排序显示优先级') }}）
        </div>
      </div>
      <div class="row-style-set">
        <div class="d-flex align-center justify-between top-title">
          <el-button type="primary" icon="el-icon-plus" @click="rowStyleAdd">
            {{ $t('创建行样式') }}
          </el-button>
          <div class="d-flex align-center" style="margin-right: -16px !important">
            <span>{{ $t('默认样式') }}</span>
            <el-popover ref="popover" :key="-1" placement="bottom" trigger="click" popper-class="popper-color-list">
              <div slot="reference" class="d-flex justify-center align-center color-box" :style="`background:${defaultRowColor};`">
                <i class="iconsimple icon-s-xiajiantou" style="color: #4e5969 !important"></i>
              </div>
              <div class="d-flex color-flip-box">
                <div
                  v-for="(colorItme, colorIndex) in defaultSelectColorList"
                  :key="colorIndex"
                  :class="[defaultRowColor === colorItme ? 'active' : '']"
                  :style="colorItme === '#fffff' || colorItme === '#FFFFFF' ? 'border: 1px solid #C9CDD4;' : `background:${colorItme};`"
                  @click="chooseColor(-1, colorItme)"
                ></div>
                <div class="color-add">
                  <el-color-picker v-model="colourPicker" popper-class="row-color-picker" @change="addColor(-1)" />
                  <div class="d-flex justify-center align-center">
                    <i class="iconsimple icon-s-jiahao"></i>
                  </div>
                </div>
              </div>
            </el-popover>
          </div>
        </div>
        <div class="center-list">
          <draggable v-model="rowStyleList" :options="dragOptions">
            <div v-for="(styleItem, styleIndex) in rowStyleList" :key="styleIndex" class="item-box d-flex align-center draggable-item draggable-handle">
              <div class="d-flex align-center item-box-dragging" style="height: 100%">
                <i class="iconsimple icon-s-tuodong2"></i>
              </div>
              <div class="item-box-set d-flex justify-between">
                <div class="item-box-left">
                  <div class="d-flex align-center justify-between" style="width: 490px; height: 32px">
                    <div class="d-flex align-center">
                      <el-input
                        v-if="styleItem.isStyleEdit"
                        :id="`inputRef${Number(styleIndex)}`"
                        v-model="styleItem.styleName"
                        :placeholder="$t('请输入样式名称')"
                        style="width: 208px"
                        @change="changeStyleName(styleItem.styleName, styleIndex)"
                        @blur="changeStyleName(styleItem.styleName, styleIndex)"
                      />
                      <div v-else class="style-name d-flex align-center">
                        <span @dblclick="handleEditName(styleIndex)">
                          {{ styleItem.styleName }}
                        </span>
                        <el-tooltip placement="bottom" popper-class="tooltip-style" class="edit-icon">
                          <div slot="content">{{ $t('修改样式名') }}</div>
                          <i class="iconsimple icon-s-bianji" @click="handleEditName(styleIndex)"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-radio-group v-model="styleItem.operator">
                      <el-radio label="OR">{{ $t('或') }}</el-radio>
                      <el-radio label="AND">{{ $t('且') }}</el-radio>
                    </el-radio-group>
                  </div>
                  <div v-for="(setItem, setIndex) in styleItem.conditionList" :key="setIndex" class="d-flex align-center justify-between" style="margin-top: 8px; width: 490px">
                    <el-select v-model="setItem.fieldName" filterable style="width: 110px" @change="changeField(setItem.fieldName, styleIndex, setIndex)">
                      <el-option v-for="(fieldItem, fieldIndex) in fieldNameList" :key="fieldIndex" :label="fieldItem.label" :value="fieldItem.value" />
                    </el-select>
                    <template>
                      <!-- 枚举字段条件 -->
                      <el-select v-if="setItem.isSelect" v-model="setItem.operator" style="width: 100px" @change="changOperator(setItem.operator, styleIndex, setIndex)">
                        <el-option v-for="(conditionItem, conditionIndex) in enumOperatorList" :key="conditionIndex" :label="conditionItem.label" :value="conditionItem.value" />
                      </el-select>
                      <!-- 自定义字段条件 -->
                      <el-select v-else-if="setItem.isDiyOperator" v-model="setItem.operator" style="width: 100px" @change="changOperator(setItem.operator, styleIndex, setIndex)">
                        <el-option v-for="(conditionItem, conditionIndex) in diyOperatorList" :key="conditionIndex" :label="conditionItem.label" :value="conditionItem.value" />
                      </el-select>
                      <!-- 常规字段条件 -->
                      <el-select v-else v-model="setItem.operator" style="width: 100px" :placeholder="setItem.isDiyOperator" @change="changOperator(setItem.operator, styleIndex, setIndex)">
                        <el-option v-for="(conditionItem, conditionIndex) in operatorList" :key="conditionIndex" :label="conditionItem.label" :value="conditionItem.value" />
                      </el-select>
                    </template>
                    <template>
                      <!-- 枚举选择 -->
                      <el-select
                        v-if="setItem.isSelect"
                        v-model="setItem.matchingText"
                        :disabled="setItem.operator === 'IS_EMPTY' || setItem.operator === 'NOT_EMPTY'"
                        :placeholder="$t('请选择匹配值')"
                        style="width: 206px"
                      >
                        <el-option v-for="(selectItem, selectIndex) in setItem.selectList" :key="selectIndex" :label="selectItem.label" :value="selectItem.value" />
                      </el-select>
                      <el-input v-else v-model="setItem.matchingText" :disabled="setItem.operator === 'IS_EMPTY' || setItem.operator === 'NOT_EMPTY'" :placeholder="$t('请输入匹配值')" style="width: 206px" />
                    </template>
                    <div class="d-flex justify-center align-center pointer" @click="addSublevel(styleIndex)">
                      <span class="iconsimple icon-s-jiahao"></span>
                    </div>
                    <div v-if="setIndex !== 0" class="d-flex justify-center align-center pointer" @click="delSublevel(styleIndex, setIndex)">
                      <span class="iconfont icon-suoxiao1"></span>
                    </div>
                    <div v-if="setIndex === 0" class="d-flex justify-center align-center">
                      <span class="iconfont icon-suoxiao1" style="color: transparent"></span>
                    </div>
                  </div>
                </div>
                <div class="item-box-right">
                  <div class="d-flex align-center">
                    <div class="d-flex justify-center align-center pointer">
                      <el-tooltip v-if="styleItem.enable" placement="bottom" popper-class="tooltip-style">
                        <div slot="content">{{ $t('隐藏样式') }}</div>
                        <span class="iconsimple icon-s-xianshi" @click="styleItem.enable = false"></span>
                      </el-tooltip>
                      <el-tooltip v-else placement="bottom" popper-class="tooltip-style">
                        <div slot="content">{{ $t('显示样式') }}</div>
                        <span class="iconsimple icon-s-yincang" @click="styleItem.enable = true"></span>
                      </el-tooltip>
                    </div>
                    <div class="d-flex justify-center align-center pointer" style="margin-left: 16px" @click="delStyle(styleIndex)">
                      <span class="iconsimple icon-s-guanbi-chaoxiao"></span>
                    </div>
                  </div>
                  <div class="d-flex justify-center align-center item-box-right-color" :style="styleItem.conditionList.length === 1 ? 'margin-top:15px' : `margin-top:${styleItem.conditionList.length * 18}px;`">
                    <el-popover ref="popover" :key="styleIndex" placement="bottom" trigger="click" popper-class="popper-color-list">
                      <div slot="reference" class="d-flex justify-center align-center color-box" :style="`background:${styleItem.color};`">
                        <i class="iconsimple icon-s-xiajiantou" style="color: #4e5969 !important"></i>
                      </div>
                      <div class="d-flex color-flip-box">
                        <div
                          v-for="(colorItme, colorIndex) in defaultSelectColorList"
                          :key="colorIndex"
                          :class="[styleItem.color === colorItme ? 'active' : '']"
                          :style="colorItme === '#fffff' || colorItme === '#FFFFFF' ? 'border: 1px solid #C9CDD4;' : `background:${colorItme};`"
                          @click="chooseColor(styleIndex, colorItme)"
                        ></div>
                        <div class="color-add">
                          <el-color-picker :key="99 + styleIndex" v-model="colourPicker" popper-class="row-color-picker" @change="addColor(styleIndex)" />
                          <div class="d-flex justify-center align-center">
                            <i class="iconsimple icon-s-jiahao"></i>
                          </div>
                        </div>
                      </div>
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
          </draggable>
        </div>
        <div v-if="!rowStyleList.length" class="mt-5">
          <el-empty :image="require('@/assets/404_images/no-data-small.png')" :description="$t('暂无行样式')" />
        </div>
      </div>
    </ku-drawer>
    <ku-message-box
      type="info"
      :tip="$t('该操作将删除整个行样式，包括所包含的匹配条件，是否确定删除')"
      :text="$t('提示')"
      :need-cancel="true"
      :can-disable-tip="false"
      :is-ads="false"
      :msg-no-more.sync="msgNoMore"
      :visible.sync="isShowDelTip"
      @confirm="delStyleConfirm"
    />
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import il8n from '@/lang';
export default {
  name: 'RowStyleSet',
  components: {
    draggable
  },
  props: {
    rowStyleVisible: {
      type: Boolean,
      default: false
    },
    styleLoading: {
      type: Boolean,
      default: false
    },
    // 字段集合
    fieldNameList: {
      type: Array,
      default: () => []
    },
    rowStyleData: {
      type: Array,
      default: () => []
    },
    // 默认色
    defaultColor: {
      type: String,
      default: '#FFFFFF'
    },
    // 默认色集合
    defaultSelectColorList: {
      type: Array,
      default: () => [
        '#FFFFFF',
        '#F7F8FA',
        '#F1FEFF',
        '#EFFAF0',
        '#FFF8EE',
        '#FFF0F0',
        '#F7F0FF',
        '#C9CDD4',
        '#E5E6E8',
        '#CCF1F4',
        '#D2F3C9',
        '#FFF2C8',
        '#FFD9D9',
        '#E8DCF6',
        '#F3AAD6',
        '#B9BDFF',
        '#BACDF0',
        '#B9D9E2',
        '#FDD2A9',
        '#FFA8A8'
      ]
    },
    // 常规规则
    operatorList: {
      type: Array,
      default: () => [
        {
          label: il8n.t('等于'),
          value: 'EQUAL'
        },
        {
          label: il8n.t('不等于'),
          value: 'NOT_EQUAL'
        },
        {
          label: il8n.t('包含'),
          value: 'CONTAINS'
        },
        {
          label: il8n.t('不包含'),
          value: 'NOT_CONTAINS'
        },
        {
          label: il8n.t('大于'),
          value: 'GREATER_THAN'
        },
        {
          label: il8n.t('大于等于'),
          value: 'GREATER_THAN_OR_EQUAL'
        },
        {
          label: il8n.t('小于'),
          value: 'LESS_THAN'
        },
        {
          label: il8n.t('小于等于'),
          value: 'LESS_THAN_OR_EQUAL'
        },
        {
          label: il8n.t('为空'),
          value: 'IS_EMPTY'
        },
        {
          label: il8n.t('不为空'),
          value: 'NOT_EMPTY'
        }
      ]
    },
    // 枚举规则
    enumOperatorList: {
      type: Array,
      default: () => [
        {
          label: il8n.t('等于'),
          value: 'EQUAL'
        },
        {
          label: il8n.t('不等于'),
          value: 'NOT_EQUAL'
        },
        {
          label: il8n.t('为空'),
          value: 'IS_EMPTY'
        },
        {
          label: il8n.t('不为空'),
          value: 'NOT_EMPTY'
        }
      ]
    },
    // 自定义规则
    diyOperatorList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isShowDelTip: false,
      delIndex: -1,
      msgNoMore: false,
      loading: false,
      drawerVisible: false,
      defaultRowColor: '#FFFFFF', // 默认色
      // 拖拽配置
      dragOptions: {
        animation: 200,
        group: 'items',
        disabled: false,
        ghostClass: 'draggable-ghost',
        handle: '.draggable-handle',
        sort: true,
        draggable: '.draggable-item'
      },
      colourPicker: '',
      rowStyleList: []
    };
  },
  watch: {
    rowStyleVisible(val) {
      this.drawerVisible = val;
    },
    defaultColor(val) {
      this.defaultRowColor = val;
    },
    styleLoading(val) {
      this.loading = val;
    },
    rowStyleData(val) {
      this.rowStyleList = val;
    }
  },
  methods: {
    // 行样式设置提交
    rowStyleSetSubmit() {
      for (let i = 0; i < this.rowStyleList.length; i++) {
        const rowStyleItem = this.rowStyleList[i];
        if (!rowStyleItem.styleName) {
          this.$message.info(this.$t('样式名称不可为空') + '！');
          return false;
        }
        for (let j = 0; j < rowStyleItem.conditionList.length; j++) {
          if (!rowStyleItem.conditionList[j].fieldName) {
            this.$message.info(this.$t('匹配字段不可为空') + '！');
            return false;
          }
          if (rowStyleItem.conditionList[j].operator !== 'IS_EMPTY' && rowStyleItem.conditionList[j].operator !== 'NOT_EMPTY') {
            if (!rowStyleItem.conditionList[j].matchingText && rowStyleItem.conditionList[j].matchingText !== 0) {
              this.$message.info(this.$t('匹配值不可为空') + '！');
              return false;
            }
          }
        }
      }
      this.$emit('saveRowStyle', {
        defaultColor: this.defaultRowColor,
        styleList: this.rowStyleList
      });
    },
    // 字段选择交互
    changeField(data, index, index1) {
      this.rowStyleList[index].conditionList[index1].isSelect = this.fieldNameList.find((v) => v.value === data).isSelect;
      this.rowStyleList[index].conditionList[index1].isDiyOperator = this.fieldNameList.find((v) => v.value === data).isDiyOperator;
      this.rowStyleList[index].conditionList[index1].selectList = this.fieldNameList.find((v) => v.value === data).selectList;
      this.rowStyleList[index].conditionList[index1].matchingText = '';
      this.rowStyleList[index].conditionList[index1].operator = 'EQUAL';
      this.$forceUpdate();
    },
    // 匹配规则交互
    changOperator(data, index, index1) {
      if (data === 'IS_EMPTY' || data === 'NOT_EMPTY') {
        this.rowStyleList[index].conditionList[index1].matchingText = '';
        this.$forceUpdate();
      }
    },
    // 样式名称交互
    changeStyleName(data, index) {
      if (!data) {
        this.$message.info(this.$t('样式名称不可为空') + '！');
        return false;
      }
      this.rowStyleList[index].isStyleEdit = false;
      this.$forceUpdate();
    },
    rowStyleAdd() {
      this.rowStyleList.push({
        conditionList: [
          {
            fieldName: '',
            operator: 'EQUAL',
            matchingText: '',
            isSelect: false,
            selectList: []
          }
        ],
        color: '#FFFFFF',
        enable: true,
        operator: 'OR',
        styleName: this.$t('样式') + Number(this.rowStyleList.length + 1),
        isStyleEdit: false
      });
      this.$nextTick(() => {
        var drawerBody = this.$el.querySelector('.el-drawer__body');
        drawerBody.scrollTop = drawerBody.scrollHeight;
      });
    },
    // 删除样式
    delStyle(index1) {
      this.isShowDelTip = true;
      this.delIndex = index1;
    },
    delStyleConfirm() {
      this.rowStyleList.splice(this.delIndex, 1);
    },
    // 编辑样式名
    handleEditName(index) {
      this.rowStyleList[index].isStyleEdit = true;
      this.$forceUpdate();
      this.$nextTick(() => {
        document.getElementById(`inputRef${index}`).focus();
      });
    },
    // 添加规则
    addSublevel(index) {
      this.rowStyleList[index].conditionList.push({
        fieldName: '',
        operator: 'EQUAL',
        matchingText: '',
        isSelect: false,
        selectList: []
      });
    },
    // 删除规则
    delSublevel(index1, index2) {
      this.rowStyleList[index1].conditionList.splice(index2, 1);
    },
    // 添加颜色
    addColor(type) {
      if (!this.colourPicker) {
        return false;
      }
      if (type === -1) {
        // 默认颜色
        this.defaultRowColor = JSON.parse(JSON.stringify(this.colourPicker));
      } else {
        // 列表颜色
        this.rowStyleList[type].color = JSON.parse(JSON.stringify(this.colourPicker));
      }
      this.$forceUpdate();
      this.colourPicker = '';
    },
    // 选择颜色
    chooseColor(type, data) {
      if (type === -1) {
        // 默认颜色
        this.defaultRowColor = data;
      } else {
        // 列表颜色
        this.rowStyleList[type].color = data;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer-title-text {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #86909c;
  span {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1d2129;
  }
}
.row-style-set {
  .top-title {
    span {
      color: #1d2129;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 600;
      display: inline-block;
      margin-right: 16px;
    }
  }
  .color-box {
    border: 1px solid #c9cdd4;
    width: 56px;
    height: 30px;
    cursor: pointer;
    font-weight: 400;
  }
  .center-list {
    margin-top: 16px;
    .item-box {
      margin-bottom: 8px;
      .item-box-dragging {
        padding: 16px;
        padding-left: 0;
        color: #c9cdd4;
        cursor: move;
      }
      .item-box-set {
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #f2f3f7;
        box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06);
        padding: 12px 0px 12px 10px;
        width: 602px;
        box-sizing: border-box;
        .item-box-left {
          color: #1d2129;
          letter-spacing: 0px;
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: 600;
          border-right: 1px solid #f2f3f7;
          padding-right: 12px;
          box-sizing: border-box;
          .style-name {
            cursor: pointer;
            span {
              display: inline-block;
              margin-top: 1px;
            }
            i {
              display: inline-block;
              color: #86909c;
              margin-left: 8px;
              font-weight: 400;
            }
            .edit-icon {
              display: none;
            }
          }
        }
        .item-box-right {
          width: 72px;
          padding: 8px 0px 8px 3px;
          box-sizing: border-box;
          span {
            color: #86909c;
          }
          .item-box-right-color {
            margin-left: -11px !important;
          }
        }
        &:hover {
          .item-box-left {
            .style-name {
              .edit-icon {
                display: block;
              }
            }
          }
        }
      }
    }
  }
}
::v-deep {
  .el-color-picker {
    background-color: transparent;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    z-index: 96 !important;
    .el-color-picker__trigger {
      width: 24px !important;
      height: 24px !important;
      border: 1px solid #4e5969;
    }
    .el-color-picker__color {
      display: none;
    }
    .el-color-picker__icon {
      display: none;
    }
  }
  .el-dialog__body .dialog__main {
    padding: 0;
  }
  .el-radio {
    margin-right: 0;
    margin-left: 15px;
  }
}
</style>
<style lang="scss">
.row-color-picker {
  position: absolute !important;
  z-index: 6000 !important;
}
.draggable-ghost {
  opacity: 0.5;
}
.draggable-handle {
  cursor: move;
  user-select: none;
}
.popper-color-list {
  padding: 0;
  z-index: 5000 !important;
  .color-flip-box {
    flex-wrap: wrap;
    width: 248px;
    padding: 16px;
    padding-top: 8px;
    box-sizing: border-box;
    > div {
      width: 24px;
      height: 24px;
      border-radius: 2px;
      box-sizing: border-box;
      margin-right: 8px;
      cursor: pointer;
      margin-top: 8px;
      &:nth-child(7n) {
        margin-right: 0;
      }
      &.active {
        border: 3px solid #3a71ff !important;
      }
    }
    .color-add {
      position: relative;
      > div {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
      }
    }
  }
}
.tooltip-style {
  max-width: 136px;
  font-size: 12px;
  line-height: 18px;
  padding: 4px 8px !important;
}
</style>
